import {ChangeDetectionStrategy, Component, ElementRef, HostBinding, Input, OnChanges, OnInit} from '@angular/core';
import {IntElementSizeAlias} from "../../../types";

@Component({
  selector: 'button[int-button], a[int-button]',
  templateUrl: './int-button.component.html',
  styleUrls: ['./int-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntButtonComponent implements OnInit, OnChanges {
  @Input() mode: 'default' | 'success' | 'danger' | string = 'default';
  @Input() size: IntElementSizeAlias = 'md';
  @Input() freeWidth = true;
  @Input() breakWords = false;

  @HostBinding('class') classes: string = '';

  constructor(
    private readonly elementRef: ElementRef
  ) {
  }

  get element() {
    return this.elementRef
  }

  setClasses() {
    this.classes = `${this.mode}-mode ${this.size} ${this.freeWidth ? 'free-width': 'limit-width'} ${this.breakWords ? 'int-btn-break-words' : ''}`;
  }

  ngOnChanges() {
    this.setClasses();
  }

  ngOnInit() {
    this.setClasses();
  }
}

